'use client';
import { AnalyticsProvider } from '@/lib/analytics-react';
import { analytics } from '@/utils/analytics';
export const AnalyticsProviderWrapper = ({
  children,
}: {
  children: React.ReactNode[];
}) => {
  return <AnalyticsProvider instance={analytics}>{children}</AnalyticsProvider>;
};
